'use client'

import {
    Flex,
    Box,
    FormControl,
    FormLabel,
    Input,
    InputGroup,
    HStack,
    InputRightElement,
    Stack,
    Button,
    Heading,
    Text,
    useColorModeValue,
    Link,
    useToast,
} from '@chakra-ui/react'
import { useState, useEffect } from 'react'
import { ViewIcon, ViewOffIcon } from '@chakra-ui/icons'
import { getAuth, createUserWithEmailAndPassword, signOut, onAuthStateChanged } from 'firebase/auth';
import { doc, setDoc, serverTimestamp } from "firebase/firestore";
import { db } from "../firebase";
import { useNavigate, Link as RouterLink } from "react-router-dom";
import { generateUniqueAnonymizedUsername } from "../utils/anonymizer";
import { getAuthErrorMessage } from '../utils/authErrors';

export default function SignupCard() {
    const [showPassword, setShowPassword] = useState(false)
    const [password, setPassword] = useState("")
    const [email, setEmail] = useState("")
    const [firstName, setFirstName] = useState("")
    const [lastName, setLastName] = useState("")
    const [isSigningUp, setIsSigningUp] = useState(false)

    const navigate = useNavigate();

    const toast = useToast()

    useEffect(() => {
        const auth = getAuth();
        console.log("auth", auth)
        if (auth.currentUser != null) {
            console.log("Should navigate")
            navigate("/");
        }
        onAuthStateChanged(auth, (user) => {
            if (user) {
                if (auth.currentUser != null) {
                    console.log("Should navigate")
                    navigate("/");
                }
            }
        });
    }, [])

    const doSignup = async () => {
        setIsSigningUp(true)
        console.log(email, password)
        const auth = getAuth();

        try {
            // Create auth user
            const userCredential = await createUserWithEmailAndPassword(auth, email, password);
            const user = userCredential.user;
            console.log("User auth", user)

            // Generate unique anonymized username
            const anonymizedUsername = await generateUniqueAnonymizedUsername(db);

            // Create user document with extended profile
            await setDoc(doc(db, "users", user.uid), {
                uid: user.uid,
                firstName,
                lastName,
                email,
                anonymizedUsername,
                reputation: {
                    rating: 0,
                    totalRatings: 0,
                    completedBounties: 0,
                    postedBounties: 0,
                },
                isAdmin: false,
                createdAt: serverTimestamp(),
            });

            console.log("Account created with username:", anonymizedUsername)
            setIsSigningUp(false)
            navigate("/tasks");

        } catch (error) {
            setIsSigningUp(false)

            // If it's a Firestore error (after user creation), sign out the user
            if (error.code && error.code.includes('firestore')) {
                try {
                    await signOut(auth);
                } catch (signOutError) {
                    console.error("Error signing out:", signOutError);
                }
                toast({
                    title: 'Error initializing account.',
                    description: getAuthErrorMessage(error),
                    status: 'error',
                    duration: 9000,
                    isClosable: true,
                })
            } else {
                // Auth error
                toast({
                    title: 'Error creating account.',
                    description: getAuthErrorMessage(error),
                    status: 'error',
                    duration: 9000,
                    isClosable: true,
                })
            }
        }
    }
    return (
        <>
            <HStack>
                <Box>
                    <FormControl id="firstName" isRequired>
                        <FormLabel>First Name</FormLabel>
                        <Input type="text" onChange={(e) => { setFirstName(e.target.value) }} />
                    </FormControl>
                </Box>
                <Box>
                    <FormControl id="lastName" isRequired>
                        <FormLabel>Last Name</FormLabel>
                        <Input type="text" onChange={(e) => { setLastName(e.target.value) }} />
                    </FormControl>
                </Box>
            </HStack>
            <Text fontSize="xs" color="gray.500" mt={-1}>Your name will not be displayed publicly.</Text>
            <FormControl id="email" isRequired>
                <FormLabel>Email address</FormLabel>
                <Input type="email" onChange={(e) => { setEmail(e.target.value) }} />
            </FormControl>
            <FormControl id="password" isRequired>
                <FormLabel>Password</FormLabel>
                <InputGroup>
                    <Input type={showPassword ? 'text' : 'password'} onChange={(e) => { setPassword(e.target.value) }} />
                    <InputRightElement h={'full'}>
                        <Button
                            variant={'ghost'}
                            onClick={() => setShowPassword((showPassword) => !showPassword)}>
                            {showPassword ? <ViewIcon /> : <ViewOffIcon />}
                        </Button>
                    </InputRightElement>
                </InputGroup>
            </FormControl>
            <Stack spacing={4} pt={2}>
                <Text fontSize="xs" color="gray.500" textAlign="center">
                    By clicking, you accept the{' '}
                    <Link as={RouterLink} to="/terms" color="orange.400" target="_blank">Terms of Service</Link>
                    {' '}and confirm that you have read the{' '}
                    <Link as={RouterLink} to="/privacy" color="orange.400" target="_blank">Privacy Policy</Link>.
                </Text>
                <Button
                    onClick={doSignup}
                    isLoading={isSigningUp}
                    loadingText='Signing Up...'
                    size="lg"
                    bg={'orange.500'}
                    color={'white'}
                    _hover={{
                        bg: 'orange.600',
                    }}>
                    Sign up
                </Button>
            </Stack>
        </>
    )
}